import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`
const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 40px; 
      height: 40px;
    }`
  }
`

const ChartBubbleIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
      <SVG xmlns="http://www.w3.org/2000/svg" width="130" height="70" viewBox="0 0 102.5 43.25" isFromWidgetChoice={isFromWidgetChoice}>
      <defs>
        <clipPath id="clipPath">
          <rect width="0.5" height="43" fill="none"/>
        </clipPath>
        <clipPath id="clipPath-2">
          <rect width="99.25" height="43" fill="none"/>
        </clipPath>
        <clipPath id="clipPath-3">
          <rect width="93.5" height="43" fill="none"/>
        </clipPath>
      </defs>
      <g id="Groupe_3896" data-name="Groupe 3896" transform="translate(-276.25 -640.5)">
        <line id="Ligne_526" data-name="Ligne 526" x2="99.5" transform="translate(276.5 683.5)" fill="none" stroke="rgba(112,112,112,0.48)" strokeWidth="0.5"/>
        <g id="Grille_de_répétition_49" data-name="Grille de répétition 49" transform="translate(276.25 640.5)" clipPath="url(#clipPath)">
          <g transform="translate(-275.25 -640.5)">
            <line id="Ligne_527" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.5"/>
          </g>
        </g>
        <g id="Ellipse_1858" data-name="Ellipse 1858" transform="translate(281 668)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="5" cy="5" r="5" stroke="none"/>
          <circle cx="5" cy="5" r="4.5" fill="none"/>
        </g>
        <g id="Ellipse_1859" data-name="Ellipse 1859" transform="translate(297 663)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="1.5" cy="1.5" r="1.5" stroke="none"/>
          <circle cx="1.5" cy="1.5" r="1" fill="none"/>
        </g>
        <g id="Ellipse_1860" data-name="Ellipse 1860" transform="translate(322 658)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="4" cy="4" r="4" stroke="none"/>
          <circle cx="4" cy="4" r="3.5" fill="none"/>
        </g>
        <g id="Ellipse_1861" data-name="Ellipse 1861" transform="translate(299 643)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="5.5" cy="5.5" r="5.5" stroke="none"/>
          <circle cx="5.5" cy="5.5" r="5" fill="none"/>
        </g>
        <g id="Ellipse_1862" data-name="Ellipse 1862" transform="translate(343 653)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="2" cy="2" r="2" stroke="none"/>
          <circle cx="2" cy="2" r="1.5" fill="none"/>
        </g>
        <g id="Ellipse_1863" data-name="Ellipse 1863" transform="translate(360 676)" fill="#fff" stroke="#707070" strokeWidth="1">
          <circle cx="1" cy="1" r="1" stroke="none"/>
          <circle cx="1" cy="1" r="0.5" fill="none"/>
        </g>
        <g id="Ellipse_1864" data-name="Ellipse 1864" transform="translate(338 676)" fill="#fff" stroke="#707070" strokeWidth="1">
          <circle cx="0.5" cy="0.5" r="0.5" stroke="none"/>
          <circle cx="0.5" cy="0.5" fill="none"/>
        </g>
        <g id="Ellipse_1865" data-name="Ellipse 1865" transform="translate(362 649)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="3" cy="3" r="3" stroke="none"/>
          <circle cx="3" cy="3" r="2.5" fill="none"/>
        </g>
        <g id="Grille_de_répétition_48" data-name="Grille de répétition 48" transform="translate(276.75 640.5)" opacity="0.2" clipPath="url(#clipPath-2)">
          <g transform="translate(-275.5 -673)">
            <line id="Ligne_528" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-275.5 -666)">
            <line id="Ligne_528-2" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-275.5 -659)">
            <line id="Ligne_528-3" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-275.5 -652)">
            <line id="Ligne_528-4" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-275.5 -645)">
            <line id="Ligne_528-5" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-275.5 -638)">
            <line id="Ligne_528-6" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-275.5 -631)">
            <line id="Ligne_528-7" data-name="Ligne 528" x2="100" transform="translate(275.5 673.5)" fill="none" stroke="#707070" strokeWidth="0.2"/>
          </g>
        </g>
        <g id="Grille_de_répétition_50" data-name="Grille de répétition 50" transform="translate(285.25 640.5)" opacity="0.74" clipPath="url(#clipPath-3)">
          <g transform="translate(-275.25 -640.5)">
            <line id="Ligne_527-2" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-265.25 -640.5)">
            <line id="Ligne_527-3" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-255.25 -640.5)">
            <line id="Ligne_527-4" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-245.25 -640.5)">
            <line id="Ligne_527-5" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-235.25 -640.5)">
            <line id="Ligne_527-6" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-225.25 -640.5)">
            <line id="Ligne_527-7" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-215.25 -640.5)">
            <line id="Ligne_527-8" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-205.25 -640.5)">
            <line id="Ligne_527-9" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-195.25 -640.5)">
            <line id="Ligne_527-10" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
          <g transform="translate(-185.25 -640.5)">
            <line id="Ligne_527-11" data-name="Ligne 527" y2="43" transform="translate(275.5 640.5)" fill="none" stroke="rgba(112,112,112,0.41)" strokeWidth="0.2"/>
          </g>
        </g>
        <g id="Ellipse_1866" data-name="Ellipse 1866" transform="translate(310 670)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="5.5" cy="5.5" r="5.5" stroke="none"/>
          <circle cx="5.5" cy="5.5" r="5" fill="none"/>
        </g>
        <g id="Ellipse_1867" data-name="Ellipse 1867" transform="translate(350 660)" fill="#707070" stroke="#707070" strokeWidth="1">
          <circle cx="4" cy="4" r="4" stroke="none"/>
          <circle cx="4" cy="4" r="3.5" fill="none"/>
        </g>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartBubbleIcon